export const APP_VERSION = {
  commitHash: '134d59d',
  pushedAt: '2026-11-04 9:11 PM EST',
};
